import { render } from "./MenuListItem.vue?vue&type=template&id=e75cd10e"
import script from "./MenuListItem.vue?vue&type=script&lang=js"
export * from "./MenuListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__